import {SuccessIcon} from "./successStyle";

const Success = () => {
    return (
        <SuccessIcon>
            <div className="sa">
                <div className="sa-success">
                    <div className="sa-success-tip"></div>
                    <div className="sa-success-long"></div>
                    <div className="sa-success-placeholder"></div>
                    <div className="sa-success-fix"></div>
                </div>
            </div>

        </SuccessIcon>
    );
};

export default Success;
